// extracted by mini-css-extract-plugin
export var deleteModal = "_gt-0";